export default "__VITE_ASSET__zV210Stc__"